export default {
  path: '/versionManage',
  name: '',
  component: () => import('@/components/layout/layout.vue'),
  redirect: '/versionManage/home',
  children: [
    {
      path: 'index',
      name: 'versionManage_index',
      component: () => import('./index')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/versionManage/router_versionManage.js